module.exports = __webpack_public_path__ + "static/pear-4f9624ca66eb78d28c6a95345b020369.svg";